import React, { useEffect } from 'react'
import { useAppFormHandler } from '@hooks'
import { BACKEND_APIS } from '@constants'
import { AutocompleteAjaxSeeker } from '@ui-seeker/core'
import { useSignal, useComputed } from '@preact/signals-react'
import { formData } from '@signals'
import { object, array } from 'yup'


export default function UserSelector() {
	const mustHide = useComputed(() => formData.value?.showCompany)
	const { uids, onUidsChange, error } = useAppFormHandler('uids', mustHide.value ? object({}) : object({ uids: array().min(1,'Must provide a user') }))
	const usersOptions = useSignal([])

	useEffect(() => {
		onUidsChange([])
	}, [mustHide.value])

	if(mustHide.value) return null

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		filters={{
			selected:uids
		}}
	urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/users`}
	onFinishAjax={options => {
		usersOptions.value = options.map(({ uid, name }) => ({ value: uid, label: name }))
	}}
	placeholder="Users"
	value={uids || []}
	onChange={e => onUidsChange(e.target.value)}
	options={usersOptions.value}
	multiple
	error={error}
	/>

}